import fetch from 'node-fetch';

/**
 * Defines available logging levels
 */
export enum LogLevel {
  None = 999,
  Info = 2,
  Warning = 3,
  Error = 4,
}

export interface RequestErrorInfo {
  cause?: string;
  source?: object | string;
  level?: LogLevel;
  request: fetch.Request | Request;
  response?: fetch.Response | Response;
}

export class RequestError extends Error {
  #source?: object | string;
  #request: fetch.Request | Request;
  #response?: fetch.Response | Response;
  message: string;
  level: LogLevel;
  /**
   * Creates a new request error instance
   */
  constructor(info: RequestErrorInfo) {
    super('');
    const { source, request, response } = info ?? {};
    if (!request) {
      throw new Error('request value required');
    }
    this.#source = source;
    this.#request = request;
    this.#response = response;
    this.level = info.level ?? LogLevel.Error;
    this.message = info?.response
      ? `Server returned status code [${info.response.status}]`
      : 'Unexpected error reading response';
  }

  source() {
    return this.#source;
  }

  request() {
    return this.#request;
  }

  response() {
    return this.#response;
  }

  toString() {
    return this.message;
  }
}
